import {useContext, useState} from 'react'

import styles from './dropdown.module.css'
import {NAME_SERVER} from "../../../Utils/NAME_HOST";
import UserService from "../../../service/UserService";
import {Context} from "../../../index";

const Dropdown_languages = (props) => {
    const disabled = false;
    const size = 40;
    const {store} = useContext(Context)
    if (!localStorage.getItem("lang")){
        localStorage.setItem("lang","ru")
    }
    const lang_id = store.user.lang?store.user.lang:localStorage.getItem("lang");

    // const { options, defaultValue, disabled, onChange } = props
    const [open, setOpen] = useState(false)
    const languages_data = {"ru":NAME_SERVER+"/assets/"+"russia.png","en":NAME_SERVER+"/assets/"+"united-states.png"}
    const [selectedValue, setSelectedValue] = useState(lang_id)

    async function change_lang(lang){
        //console.log(store.isAuth)
        if (store.isAuth){
            await UserService.changeLang(lang)

        }

        localStorage.setItem("lang",lang)

        setSelectedValue(lang)
        setOpen(false)
        window.location.reload()


    }

    return (
        <div className={styles.dropdown}>
            <div
                className={`selected text-option ${disabled ? 'disabled' : ''} ${
                    open ? 'open' : ''
                }`}
                onClick={() => !disabled && setOpen((prev) => !prev)}
            >
                <img src={languages_data[selectedValue]} width={size} height={size}/>

            </div>
            {open ? (
                <>
                        <div className="dropdown-items">
                        {Object.keys(languages_data).map((option, index) => (
                            <div className="item text-option" onClick={async () => change_lang(option)}>
                                <img src={languages_data[option]} width={size} height={size}/>
                            </div>

                        ))}


                    </div>

                    <div className="blank" onClick={() => setOpen(false)} />


                </>
            ) : (
                <></>
            )}
        </div>
    )
}

export default Dropdown_languages
